import { Components } from '@mui/material';
import { getDataGridUtilityClass } from '@mui/x-data-grid';
import type {} from '@mui/x-data-grid/themeAugmentation';

import DataGridLoadingOverlay from '../../../components/DataGrid/DataGridLoadingOverlay';
import DataGridPagination from '../../../components/DataGrid/DataGridPagination';
import tokens from '../tokens';

const MuiDataGrid: NonNullable<Components['MuiDataGrid']> = {
  defaultProps: {
    autoHeight: true,
    pagination: true,
    paginationMode: 'server',
    sortingMode: 'server',
    disableColumnFilter: true,
    disableColumnMenu: true,
    disableColumnSelector: true,
    disableSelectionOnClick: true,
    disableDensitySelector: true,
    disableExtendRowFullWidth: true,
    headerHeight: 64,
    rowHeight: 56,
    components: {
      Pagination: DataGridPagination,
      LoadingOverlay: DataGridLoadingOverlay,
    },
  },
  styleOverrides: {
    root: {
      borderRadius: 6,
      boxShadow: tokens.shadows[2],
      border: 0,
      background: tokens.palette.background.paper,
      fontSize: `${14 / 16}rem`,
      lineHeight: (20 / 14).toPrecision(2),
      letterSpacing: '0.0125em',

      [`& .${getDataGridUtilityClass('cell')}, & .${getDataGridUtilityClass('columnHeader')}`]: {
        padding: `0 ${tokens.spacing(1.25)}`,
      },
      [`&.${getDataGridUtilityClass('root')}`]: {
        [[
          `& .${getDataGridUtilityClass('columnHeader')}:focus`,
          `& .${getDataGridUtilityClass('columnHeader')}:focus-within`,
          `& .${getDataGridUtilityClass('cell')}:focus`,
          `& .${getDataGridUtilityClass('cell')}:focus-within`,
        ].join(',')]: {
          outline: 'none',
        },
      },

      [`& .${getDataGridUtilityClass('columnSeparator')}`]: {
        display: 'none',
      },

      [`& .${getDataGridUtilityClass('columnHeaderTitleContainer')}`]: {
        padding: 0,

        [`& .${getDataGridUtilityClass('columnHeaderTitle')}`]: {
          color: tokens.palette.text.primary,
          fontWeight: 600,
          fontSize: '0.75rem',
          lineHeight: 1.5,
          letterSpacing: '0.04em',
        },
      },

      [`& .${getDataGridUtilityClass('columnHeader')}`]: {
        textTransform: 'uppercase',
      },

      [[
        `& .${getDataGridUtilityClass('virtualScrollerContent')} .${getDataGridUtilityClass('cell')}`,
        `& .${getDataGridUtilityClass('columnHeaders')}`,
        `& .${getDataGridUtilityClass('columnHeader')}`,
      ].join(',')]: {
        borderBottom: 0,
      },

      [`& .${getDataGridUtilityClass('virtualScrollerContent')}`]: {
        minHeight: '100%',
      },

      [`& .${getDataGridUtilityClass('virtualScrollerRenderZone')}`]: {
        marginBottom: '2rem',
      },

      [`& .${getDataGridUtilityClass('row')}:nth-of-type(even)`]: {
        // TODO: add to palette
        background: '#f3faff',
      },

      [`& .${getDataGridUtilityClass('cell--action')}`]: {
        paddingRight: tokens.spacing(2),
        paddingLeft: tokens.spacing(2),
      },
    },
  },
};

export default MuiDataGrid;
